export default "__VITE_ASSET__CcopenLo__"